import * as React from 'react';
import Popper from '@mui/material/Popper';

function BottomPopper({ props }) {
  return (
    <Popper
      {...props}
      placement="bottom"
      disablePortal={false}
      modifiers={[
        {
          name: 'flip',
          enabled: false,
          options: {
            altBoundary: true,
            rootBoundary: 'document',
            padding: 8,
          },
        },
        {
          name: 'preventOverflow',
          enabled: true,
          options: {
            altAxis: true,
            altBoundary: false,
            tether: true,
            rootBoundary: 'document',
            padding: 8,
          },
        }
      ]}
    />
  )
}

export default BottomPopper